import { elementToPNG } from "../../services/screenshot";

export const downloadreceipt = (fn?: any) => {
	const handler = () => {
		fn?.();
		setTimeout(() => {
			elementToPNG("ReceiptCapture", "receipt");
		}, 200);
	};

	return handler;
};
